import React from 'react';

const BaseSection = (
    { id, name, introduction, iSize, iColor, styles = '', children },
    ref,
) => {
    return (
        <section id={id} ref={ref}>
            <span className="section-name block mb-4">{name}</span>
            <h1 className={`section-introduction ${iSize} ${iColor} ${styles}`}>
                {introduction}
            </h1>

            {children}
        </section>
    );
};

export default React.forwardRef(BaseSection);
